import type { LeadsSearchColumnListConfig } from "app/pages/sales-intelligence/modules/leads-search";
import {
    createCRMListsColumnList,
    createListsColumnList,
} from "app/pages/sales-intelligence/modules/lists/configuration/columns/columnList";

export const listsColumnConfig: LeadsSearchColumnListConfig = createListsColumnList();
export const crmListsColumnConfig: LeadsSearchColumnListConfig = createCRMListsColumnList();
